import React from 'react';

import WelcomeScreen from '../components/Welcome';
import PrivacyPolicy from '../components/PrivacyPolicy';

const PrivacyPolicyPage: React.FC = () => {	
	return (
		<div className="min-h-screen bg-primary">
			<WelcomeScreen />
			
			<div className='flex justify-center w-full'>
				<div className='pl-5 pr-5'>
					<div className='text-white mb-10'>
						<PrivacyPolicy/>
						
						<p className='mt-20 mb-20 text-white'>
							For Terms & Privacy Policy pages on the app, is it possible to update the below section to say: <br/>
							If you have questions or comments about this notice, you may email us at <a className='font-bold' href="mailto:ntkcllc@gmail.com">ntkcllc@gmail.com</a> or contact us by phone at <a className='font-bold' href="tel:+17277736174">+1-727-773-6174</a></p>
					</div>
				</div>
			</div>
			
		</div>
	);
};

export default PrivacyPolicyPage;